import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createInvitationApi } from '../-api/api';
import type { CreateInvitationPayload } from '../-api/types';

export function useCreateInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { orgUrn: string; payload: CreateInvitationPayload }) =>
      createInvitationApi(data.orgUrn, data.payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sent-invitations'] });
    },
  });
}
